import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import {
  Button,
  Form,
  Segment,
  Message,
} from 'semantic-ui/semantic-ui-imports';
import { AxiosError } from 'axios';
import axios, { refreshCsrfToken } from '../../services/request';
import './index.scss';

type Errors = {
  email: Array<string>;
};

function ResetPasswordForm() {
  // translation
  const { t } = useTranslation();

  // state
  const [email, setEmail] = React.useState<string>();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [isLinkSent, setIsLinkSent] = React.useState<boolean>(false);
  const [errors, setErrors] = React.useState<Errors>();

  React.useEffect(() => {
    setErrors(undefined);
  }, [email]);

  const onSubmit = async () => {
    setIsLoading(true);

    await refreshCsrfToken();

    try {
      await axios.post(`/rest-auth/password/reset/`, { email });
      setIsLinkSent(true);
      setIsLoading(false);
    } catch (error) {
      const err: AxiosError = error as AxiosError;
      if (err.response) {
        setErrors(err.response?.data);
      }
      setIsLoading(false);
    }
  };

  return (
    <div className="reset-password">
      {!isLinkSent && (
        <Form className="reset-password__form" onSubmit={onSubmit}>
          <Segment>
            <Form.Field>
              <Form.Input
                name="email"
                label={t('resetPasswordPage.emailLabel')}
                fluid
                icon="mail"
                iconPosition="left"
                placeholder={t('resetPasswordPage.email')}
                type="email"
                onChange={(e: any, { value }: any) => setEmail(value)}
                error={errors?.email}
              />
            </Form.Field>
            {errors && (
              <Message negative>
                <p>
                  {t('resetPasswordPage.linkNotSentError')} -{' '}
                  {t('resetPasswordPage.linkNotSent')}
                </p>
              </Message>
            )}
            <Button
              disabled={isLoading}
              loading={isLoading}
              color="teal"
              fluid
              size="large"
              type="submit"
            >
              {t('resetPasswordPage.submit')}
            </Button>
            <div>
              <Link to="/login">{t('resetPasswordPage.loginLink')}</Link>
            </div>
          </Segment>
        </Form>
      )}
      {isLinkSent && (
        <Message positive>
          <p>{t('resetPasswordPage.linkSent')}</p>
        </Message>
      )}
    </div>
  );
}

export default ResetPasswordForm;
